import { render, staticRenderFns } from "./ReintegriCards.vue?vue&type=template&id=5c98925e"
import script from "./ReintegriCards.vue?vue&type=script&lang=ts"
export * from "./ReintegriCards.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c98925e')) {
      api.createRecord('5c98925e', component.options)
    } else {
      api.reload('5c98925e', component.options)
    }
    module.hot.accept("./ReintegriCards.vue?vue&type=template&id=5c98925e", function () {
      api.rerender('5c98925e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ReintegriCards.vue"
export default component.exports